var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ViewerItem',{staticClass:"link",attrs:{"model_id":_vm.contractStock.stock_id,"type":"StockCalculator","show_type":"drawer","tip":false}},[_vm._v(" 最佳采购量计算 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }